"use strict";
(self["webpackChunkdefault_theme"] = self["webpackChunkdefault_theme"] || []).push([["/assets/app"],{

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _collection_init__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./collection/init */ "./src/js/collection/init.js");
/* harmony import */ var _wishlist_init__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./wishlist/init */ "./src/js/wishlist/init.js");


new _collection_init__WEBPACK_IMPORTED_MODULE_0__["default"]();
new _wishlist_init__WEBPACK_IMPORTED_MODULE_1__["default"]();

// Example for importing a Vue component
//import { createApp } from 'vue';
// import Example from '../vue/Example.vue';
// createApp(Example).mount('#app');

// console.log('vue component should be loaded');

/***/ }),

/***/ "./src/js/collection/init.js":
/*!***********************************!*\
  !*** ./src/js/collection/init.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Collection = /*#__PURE__*/_createClass(function Collection() {
  var _this = this;
  _classCallCheck(this, Collection);
  _defineProperty(this, "loadMore", function () {
    var buttons = document.querySelectorAll('.js-load-more');
    if (buttons.length) {
      buttons.forEach(function (button) {
        return button.addEventListener('click', _this.loadMoreEvent);
      });
    }
  });
  _defineProperty(this, "loadMoreEvent", function (e) {
    e.preventDefault();
    var toggleTarget = e.target.parentElement;
    var showMoreText = e.target.dataset.more;
    var showLessText = e.target.dataset.less;
    if (!toggleTarget) {
      return;
    }
    toggleTarget.classList.toggle('description__column--all');
    if (toggleTarget.classList.contains('description__column--all')) {
      e.target.innerText = showLessText;
    } else {
      e.target.innerText = showMoreText;
    }
  });
  this.loadMore();
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Collection);

/***/ }),

/***/ "./src/js/wishlist/init.js":
/*!*********************************!*\
  !*** ./src/js/wishlist/init.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Wishlist = /*#__PURE__*/_createClass(function Wishlist() {
  var _this = this;
  _classCallCheck(this, Wishlist);
  _defineProperty(this, "getVariantInfo", function (variants) {
    try {
      var variantKeys = variants && variants != "[]" ? Object.keys(JSON.parse(variants)[0]) : [],
        variantinfo;
      if (variantKeys.length > 0) {
        variantinfo = variantKeys[0];
        if (variantinfo == "Default Title") {
          variantinfo = "";
        }
      } else {
        variantinfo = "";
      }
      return variantinfo;
    } catch (err) {
      return variants;
    }
  });
  _defineProperty(this, "onAddToCartClick", function (e) {
    e.preventDefault();
    var productId = e.currentTarget.getAttribute("data-product-id");
    var variantId = e.currentTarget.getAttribute("data-variant-id");
    var du = e.target.getAttribute("data-product-url");
    e.target.innerHTML = "Adding..";
    window._swat.replayAddToCart({
      empi: productId,
      du: du
    }, variantId, function (c) {
      e.target.innerHTML = "Added to Cart";
      e.target.setAttribute("data-state-cart", "swym-added");
      //console.log("Successfully added product to cart.", c);
    }, function (e) {
      //console.log(e);
    });
  });
  _defineProperty(this, "onRemoveBtnClick", function (e) {
    e.preventDefault();
    var epi = +e.currentTarget.getAttribute("data-variant-id");
    var empi = +e.currentTarget.getAttribute("data-product-id");
    window._swat.fetch(function (products) {
      products.forEach(function (product) {
        if (epi && empi && product.epi == epi && product.empi == empi) {
          window._swat.removeFromWishList(product, function () {
            if (!window.SwymCallbacks) {
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(_this.swymRenderWishlist);
          });
        }
      });
    });
  });
  _defineProperty(this, "attachClickListeners", function () {
    var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
    var removeBtns = document.querySelectorAll("#swym-remove-productBtn");

    //   Add to cart Btns
    for (var i = 0; i < addToCartButtons.length; i++) {
      addToCartButtons[i].addEventListener('click', _this.onAddToCartClick, false);
    }
    //   Remove Buttons
    for (var k = 0; k < removeBtns.length; k++) {
      removeBtns[k].addEventListener('click', _this.onRemoveBtnClick, false);
    }
  });
  _defineProperty(this, "swymRenderWishlist", function (swat) {
    /* Product Tile Markup - You can play around with this to change the
    information that appears on the Wishlisted Product tiles  */
    var productCardMarkup = "<div class=\"swym-wishlist-grid products row\">\n        {{#products}} \n        <div class=\"product product--wishlist col-lg-3 col-md-4 col-sm-6 col-xs-6 col-6\">\n            <div class=\"inner\">\n                 \n                <div class=\"product__imageWrap swym-wishlist-image-wrapper\">\n                    <div class=\"product__labels\">\n                        <div id=\"swym-remove-productBtn\" aria-label=\"Delete\" data-variant-id=\"{{epi}}\" data-product-id=\"{{empi}}\" class=\"swym-delete-btn swym-nav swym-nav-1 swym-is-button\">\n                            <div class=\"product__wishlist\">\n                                <i class='bx bx-x'></i>\n                            </div>\n                        </div>\n                    \n                    </div>\n                    \n                    <a href=\"{{du}}\"aria-label=\"{{dt}}\" class=\"swym-wishlist-item swym-is-anchor\">\n                        <img class=\"product__image swym-wishlist-image\" src=\"{{iu}}\" alt=\"\">\n                    </a>\n                </div>\n               \n\n                <div class=\"product__info product__info--default\">\n\n                    <div class=\"product__top\">\n\n                        <div class=\"product__title\">\n\n                            <a href=\"{{ du }}\" title=\"{{ title }}\">{{ title }}</a>\n\n                        </div>\n\n                    </div>\n                    <div class=\"product__priceWrapper\">\n\n                \n                        <div class=\"product__price\">\n\n                            {{ cu }}{{ pr }}\n\n                        </div>\n\n\n                    </div>\n                </div>\n\n            </div>\n        </div>\n        {{/products}}\n        </div>";

    // Get wishlist items
    swat.fetch(function (products) {
      var wishlistContentsContainer = document.getElementById("wishlist-items-container");
      var wishlistCount = document.getElementById("wishlist-count");
      var formattedWishlistedProducts = products.map(function (p) {
        p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
        p.variantinfo = p.vi ? _this.getVariantInfo(p.vi) : "";
        p.title = p.dt;
        return p;
      });
      var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
        products: formattedWishlistedProducts
      });
      wishlistCount.innerHTML = products.length;
      if (wishlistContentsContainer) {
        if (products.length > 0) {
          wishlistContentsContainer.innerHTML = productCardsMarkup;
        } else {
          wishlistContentsContainer.innerHTML = 'Nog geen producten in wishlist';
        }
      } else {
        //console.log("Container not found, Wishlist Page element not found");
      }
      _this.attachClickListeners();
    });
  });
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(this.swymRenderWishlist); /* Init Here */
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Wishlist);

/***/ }),

/***/ "./src/sass/style-collection.scss":
/*!****************************************!*\
  !*** ./src/sass/style-collection.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sass/style-general.scss":
/*!*************************************!*\
  !*** ./src/sass/style-general.scss ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sass/vendors.scss":
/*!*******************************!*\
  !*** ./src/sass/vendors.scss ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, ["assets/vendors","assets/style-general","assets/style-collection"], () => (__webpack_exec__("./src/js/app.js"), __webpack_exec__("./src/sass/style-collection.scss"), __webpack_exec__("./src/sass/style-general.scss"), __webpack_exec__("./src/sass/vendors.scss")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);